export default "__VITE_ASSET__CiUqWxAi__"